<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-monitor-edit
        </v-icon>Edit Digi-Board
      </h2>
      <v-form>
        <v-container class="my-container-style">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="location"
              label="Digi-Board Location*"
            />
          </v-col>

          <v-col
            cols="12"
          >
            <v-text-field
              v-model="boardNumber"
              label="Digi-Board Number"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="externalId"
              label="Digi-board Id*"
              disabled
            />
          </v-col>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="update()"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'EditDigiBoard',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      digiBoardId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        showModal: true,
        location: '',
        boardNumber: '',
        externalId: '',
        loading: false,
      };
    },
    computed: {
      editDigiBoardContent () {
        return this.$store.getters['digiboards/getDigiBoardContent'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.fillData();
    },
    methods: {
      async fillData () {
        this.loading = true;
        const digiBoardId = this.digiBoardId;
        await this.$store.dispatch('digiboards/fetchDigiBoardContent', {
          params: {
            digiBoardId: digiBoardId,
          },
        }).then(response => {
          this.location = this.editDigiBoardContent.location;
          this.boardNumber = this.editDigiBoardContent.board_number;
          this.externalId = this.editDigiBoardContent.external_id;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      update () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Yor are not authorized to update the digi-board contents at the moment.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        this.showModal = false;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-right: 5px;
}
.my-container-style {
    padding-top: 24px;
}
</style>
